<app-breadcrumbs title="Material Consumption" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5>Material Consumption</h5>
    <button class="btn btn-success" (click)="toggleForm()">
      <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'"></i>
      {{ showForm ? 'Cancel' : 'Add Consumption' }}
    </button>
  </div>

  <div *ngIf="showForm" class="card-body border-bottom">
    <form [formGroup]="consumptionForm" (ngSubmit)="saveConsumption()">
      <div class="row g-3">
        <div class="col-md-4">
          <label>Item <span class="text-danger">*</span></label>
          <select formControlName="item_id" class="form-control" [class.is-invalid]="submitted && f['item_id'].errors">
            <option value="">Select Item</option>
            <option *ngFor="let item of items" [value]="item.id">
              {{ item.name || item.item_name || 'Item #' + item.id }}
            </option>
          </select>
          <div *ngIf="submitted && f['item_id'].errors" class="invalid-feedback">
            <span *ngIf="f['item_id'].errors['required']">Item is required</span>
          </div>
        </div>
        <div class="col-md-4">
          <label>Quantity <span class="text-danger">*</span></label>
          <input type="number" formControlName="quantity" class="form-control" 
                 [class.is-invalid]="submitted && f['quantity'].errors" placeholder="Enter quantity" />
          <div *ngIf="submitted && f['quantity'].errors" class="invalid-feedback">
            <span *ngIf="f['quantity'].errors['required']">Quantity is required</span>
            <span *ngIf="f['quantity'].errors['min']">Quantity must be at least 1</span>
          </div>
        </div>
        <div class="col-md-4">
          <label>Purpose <span class="text-danger">*</span></label>
          <input formControlName="purpose" class="form-control" 
                 [class.is-invalid]="submitted && f['purpose'].errors" placeholder="Enter purpose" />
          <div *ngIf="submitted && f['purpose'].errors" class="invalid-feedback">
            <span *ngIf="f['purpose'].errors['required']">Purpose is required</span>
          </div>
        </div>
        <div class="col-md-12">
          <label>Remarks</label>
          <textarea formControlName="remarks" class="form-control" rows="2" placeholder="Enter remarks"></textarea>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button class="btn btn-light" type="button" (click)="toggleForm()">Cancel</button>
        <button class="btn btn-success" type="submit">{{ isEditMode ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>


  <div class="card-body">
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <table class="table">
        <thead class="table-light">
          <tr>
            <th>Handover #</th>
            <th>Item</th>
            <th>Quantity</th>
            <th>Type</th>
            <th>Purpose</th>
            <th>Handed By</th>
            <th>Status</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let consumption of consumptions">
            <td><strong>{{ consumption?.handoverNumber || '#' + consumption?.id }}</strong></td>
            <td>
              {{ consumption?.item?.name || 'N/A' }}
              <small class="text-muted d-block">{{ consumption?.item?.code }}</small>
            </td>
            <td>
              <span class="badge bg-info">{{ consumption.quantity }} {{ consumption?.item?.unit?.symbol }}</span>
            </td>
            <td>
              <span class="badge bg-primary-subtle text-primary">{{ consumption.handoverType }}</span>
            </td>
            <td>{{ consumption.purpose }}</td>
            <td>{{ consumption?.handoverUser?.fullName || 'N/A' }}</td>
            <td>
              <span class="badge" 
                    [ngClass]="consumption.status === 'Completed' ? 'bg-success' : 
                               consumption.status === 'Pending' ? 'bg-warning' : 'bg-secondary'">
                {{ consumption.status }}
              </span>
            </td>
            <td>{{ consumption.handoverDate | date:'mediumDate' }}</td>
            <td class="d-flex gap-2">
              <button class="btn btn-sm btn-success" (click)="editConsumption(consumption)"><i class="ri-edit-2-line"></i></button>
              <button class="btn btn-sm btn-danger" (click)="deleteConsumption(consumption.id)"><i class="ri-delete-bin-line"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="consumptions.length > 0" class="mb-2 row">
        <div class="dataTables_info mb-2 col col-sm-6">
            Showing {{ (page - 1) * pageSize + 1 }}
            to {{ getMin(page * pageSize, totalItems) }}
            of {{ totalItems }} entries
        </div>
        <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
                <ngb-pagination
                    [collectionSize]="totalItems"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="changePage($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
  </div>

   
  </div>
</div>
